import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'

import Form from './Form'
import Confirmation from './Confirmation'
import Complete from './Complete'

export const STEP_CREDENTIALS = 'credentials'
export const STEP_VERIFICATION_CODE = 'verification-code'
export const STEP_COMPLETE = 'complete'

export const Signup = (props) => {
  const { errors, disabled, email, showTitle, isInProgress, message, currentStep } = props

  const sharedStepProps = {
    errors,
    disabled,
    email,
    showTitle,
    isInProgress,
    message,
  }

  const topElementRef = useRef(null)
  const liveRegionRef = useRef(null)

  useEffect(() => {
    window.scrollTo(0, 0)

    if (topElementRef.current) {
      topElementRef.current.focus()
    }

    if (liveRegionRef.current) {
      liveRegionRef.current.innerHTML = `Step changed to: ${currentStep === STEP_CREDENTIALS ? 'Enter details' : currentStep === STEP_VERIFICATION_CODE ? 'confirmation code' : 'Sign up complete'}`;
    }

    let newTitle = 'Create an account - Business.gov.uk'
    
    if (currentStep === STEP_CREDENTIALS) {
      newTitle = 'Create an account - Business.gov.uk'
    } else if (currentStep === STEP_VERIFICATION_CODE) {
      newTitle = 'Create an account - Check your email and enter the verification code - Business.gov.uk'
    } else if (currentStep === STEP_COMPLETE) {
      newTitle = 'Create an account - Sign up complete - Business.gov.uk'
    }

    document.title = newTitle
  }, [currentStep])

  function renderStep() {
    if (currentStep === STEP_CREDENTIALS) {
      return (
        <Form
          {...sharedStepProps}
          handleEmailChange={props.setEmail}
          handlePasswordChange={props.setPassword}
          password={props.password}
          phoneNumber={props.phoneNumber}
          isBgsSite={props.isBgsSite}
          handlePhoneNumber={props.setPhoneNumber}
          linkedinLoginUrl={props.linkedinLoginUrl}
          googleLoginUrl={props.googleLoginUrl}
          handleSubmit={props.handleStepCredentialsSubmit}
          termsAndConditions={props.termsAndConditions}
          handleTermsAndConditionsChange={props.setTermsAndConditions}
        />
      )
    }

    if (currentStep === STEP_VERIFICATION_CODE) {
      return (
        <Confirmation
          {...sharedStepProps}
          handleSubmit={props.handleStepCodeSubmit}
          handleCodeChange={props.setCode}
          code={props.code}
        />
      )
    }

    if (currentStep === STEP_COMPLETE) {
      return <Complete nextUrl={props.nextUrl} />
    }

    return null
  }

  return (
    <div className="great signup great-ds-container">
      <div ref={topElementRef} tabIndex="-1" style={{ position: 'absolute', top: 0, left: 0 }}>
      </div>

      <div 
        ref={liveRegionRef} 
        aria-live="polite" 
        style={{ position: 'absolute', width: 0, height: 0, overflow: 'hidden' }}
      >
      </div>

      <div className="signup__form-panel govuk-!-margin-top-9">
        {renderStep()}
      </div>
    </div>
  )
}

Signup.propTypes = {
  ...Form.propTypes,
  isInProgress: PropTypes.bool,
  currentStep: PropTypes.oneOf([STEP_CREDENTIALS, STEP_COMPLETE, STEP_VERIFICATION_CODE]),
  showTitle: PropTypes.bool,
  message: PropTypes.string,
}

Signup.defaultProps = {
  ...Form.defaultProps,
  isInProgress: false,
  currentStep: STEP_CREDENTIALS,
  showTitle: true,
  message: '',
}
